import {
	deploymentSitePublicWebOrigin,
	inferPublicDeployEnvFromHost,
	normalizeDeploymentSiteCodeForPublicWeb,
} from "le-coffre-resources/dist/deploymentSitePublicWeb.js";
import { getPublicSiteCode } from "@Front/themes/siteTheme";

/**
 * Origine publique v2 (`https://www.lecoffre.io` en prod **lecoffreio** ; **`https://{env}.lecoffreio.4nkweb.com`** hors prod).
 * Navigateur : **`window.location`** ; SSR / build : **`NEXT_PUBLIC_FRONT_APP_HOST`**.
 */
export function resolvePublicWebOriginForBrowserOrBuild(): string {
	const site = normalizeDeploymentSiteCodeForPublicWeb(getPublicSiteCode());
	const hostSource =
		typeof window !== "undefined" && typeof window.location?.href === "string"
			? window.location.href
			: (process.env["NEXT_PUBLIC_FRONT_APP_HOST"] ?? "");
	const env = inferPublicDeployEnvFromHost(hostSource);
	return deploymentSitePublicWebOrigin(site, env);
}

/** Hôte seul (sans schéma), pour libellés métier. */
export function resolvePublicWebDisplayHostForBrowserOrBuild(): string {
	return resolvePublicWebOriginForBrowserOrBuild().replace(/^https?:\/\//, "");
}
